<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="frontmatter">
<blockquote>
<p class="SP"> </p>
<p class="Letter-Ext-Address-ladd"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">Janelle Holland, 10th Grade PE Teacher</span></p>
<p class="Letter-Ext-Address-ladd">Sir Alexander Galt High School</p>
<p class="Letter-Ext-Address-ladd">Lethbridge, Alberta</p>
<p class="Letter-Ext-Salutation-lsa">Dear Parents and Guardians,</p>
<p class="Letter-Ext-Body-Text-No-Indent-ltx1">On Thursday and Friday, October 17 and 18, the PE 10 class of Sir Alexander Galt High School will participate in an overnight class field trip to Waterton Lakes National Park. This field trip is a required portion of the outdoor ed curriculum and will involve two day hikes and an overnight tenting experience.</p>
<p class="Letter-Ext-Body-Text-ltx">NOTE: Students cannot pass the class without it.</p>
<p class="Letter-Ext-Body-Text-ltx">Students should arrive on campus Thursday at 7:30 a.m. with their equipment packed and ready. (See attached list.) The class will leave the school by bus at 8:00 a.m. and head to Waterton Park, arriving at Red Rock Canyon at 10:00 a.m. Students will hike the Snowshoe Trail, have a bagged lunch en route near Avion Ridge, and will reach Twin Lakes campground by nightfall where dinner will be provided. The following morning, students will eat breakfast before hiking the Blakiston Trail side of the loop back to Red Rock Canyon, again having lunch on the trail. Both of Friday’s meals are provided. Snacks are not. The bus will return to Lethbridge and drop the class off at the school at 10:00 p.m. Friday.</p>
<p class="Letter-Ext-Body-Text-ltx">A total of three teachers will act as class escorts to ensure the safety of the entire class during this field trip. These are: Mr. Karl Perkins, Mr. Ron Barry, and myself. Tents, sleeping bags, <span aria-label="viii" id="pg_viii" role="doc-pagebreak">and the main meals will be provided, but students should bring a bagged lunch for Thursday and any snacks they might want. Please note: PHONES AND TABLETS ARE NOT PERMITTED. (If your child would like to take photos, they will need to bring a camera.)</span></p>
<p class="Letter-Ext-Body-Text-ltx">Please sign the consent form and have your child return it to the school office before Thursday. If you have any concerns, feel free to contact me directly.</p>
<p class="Letter-Ext-Closing-lcl">Sincerely,</p>
<p class="Letter-Ext-Signature-lsig">Ms. Janelle Holland, BSc, BEd<br/>Physical Education Department<br/>Sir Alexander Galt High School</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?7e53640c